import React from 'react';
import { useFormat } from 'helpers/hooks/useFormat';

export type ShippingMethod = 'standard' | 'pickup';

interface Props {
  onSelectMethod: (method: ShippingMethod) => void;
}

export const ShippingMethodSelector: React.FC<Props> = ({ onSelectMethod }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className="mx-auto max-w-4xl space-y-8 p-8">
      <div className="text-center">
        <h1 className="mb-2 text-3xl font-bold">
          {formatMessage({
            id: 'shipping.selectMethod',
            defaultMessage: 'Seleziona il metodo di spedizione',
          })}
        </h1>
        <p className="text-gray-600">
          {formatMessage({
            id: 'shipping.selectMethodDescription',
            defaultMessage: 'Scegli come desideri ricevere il tuo ordine',
          })}
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        {/* Standard Shipping */}
        <button
          onClick={() => onSelectMethod('standard')}
          className="group flex flex-col rounded-lg border-2 border-gray-200 bg-white p-6 text-left transition-all hover:border-gray-900 hover:shadow-lg"
        >
          <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-gray-100 group-hover:bg-gray-900">
            <svg
              className="size-6 text-gray-600 group-hover:text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
          </div>
          <h3 className="mb-2 text-xl font-semibold">
            {formatMessage({
              id: 'shipping.standard',
              defaultMessage: 'Spedizione standard',
            })}
          </h3>
          <p className="text-gray-600">
            {formatMessage({
              id: 'shipping.standardDescription',
              defaultMessage: 'Ricevi il tuo ordine direttamente a casa',
            })}
          </p>
        </button>

        {/* Pickup Point */}
        <button
          onClick={() => onSelectMethod('pickup')}
          className="group flex flex-col rounded-lg border-2 border-gray-200 bg-white p-6 text-left transition-all hover:border-gray-900 hover:shadow-lg"
        >
          <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-gray-100 group-hover:bg-gray-900">
            <svg
              className="size-6 text-gray-600 group-hover:text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <h3 className="mb-2 text-xl font-semibold">
            {formatMessage({
              id: 'shipping.pickup',
              defaultMessage: 'Punto di ritiro',
            })}
          </h3>
          <p className="text-gray-600">
            {formatMessage({
              id: 'shipping.pickupDescription',
              defaultMessage: 'Ritira il tuo ordine presso un punto di ritiro vicino a te',
            })}
          </p>
        </button>
      </div>
    </div>
  );
};
